export default __webpack_public_path__ + "static/hero-2a60885de10dbcd7e6e39ff0d9e1177e.png";